import { createContext, useContext, useState, useEffect } from 'react';

const ChatThemeContext = createContext();

export const ChatThemeProvider = ({ children }) => {
  const [isChatDarkMode, setIsChatDarkMode] = useState(() => {
    // Inicializa do localStorage ou false por padrão
    const saved = localStorage.getItem('lexfy-chat-theme') || localStorage.getItem('theme');
    return saved === 'dark';
  });

  // Aplica o tema ao document.documentElement sempre que mudar
  useEffect(() => {
    if (isChatDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
      localStorage.setItem('lexfy-chat-theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
      localStorage.setItem('lexfy-chat-theme', 'light');
    }
  }, [isChatDarkMode]);

  const toggleChatTheme = () => {
    const newMode = !isChatDarkMode;
    setIsChatDarkMode(newMode);
    // Dispara evento para sincronizar com outros componentes
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <ChatThemeContext.Provider value={{
      isChatDarkMode,
      toggleChatTheme
    }}>
      {children}
    </ChatThemeContext.Provider>
  );
};

export const useChatTheme = () => {
  const context = useContext(ChatThemeContext);
  if (!context) {
    throw new Error('useChatTheme must be used within a ChatThemeProvider');
  }
  return context;
};